/**
 * Billing account control module
 */
import { requestData } from "./utils";
import ApiKeyModule from "./api_key";

export default class BillingModule {
  constructor() {
    this.apiKey = new ApiKeyModule();

    this.account = {
      add(billing_account, enterprise_id, entity_id) {
        billing_account.credit_limit = billing_account.credit_limit
          ? billing_account.credit_limit === ""
            ? 0
            : billing_account.credit_limit
          : 0;

        return requestData("POST", `/billing_account`, {
          billing_account: {
            ...billing_account,
            enterprise_id,
            entity_id,
          },
        });
      },
      get(billing_account_id) {
        return requestData("GET", `/billing_account/${billing_account_id}`);
      },
      update(billing_account_id, billing_account) {
        billing_account.credit_limit = billing_account.credit_limit
          ? billing_account.credit_limit === ""
            ? 0
            : billing_account.credit_limit
          : 0;

        return requestData("PUT", `/billing_account/${billing_account_id}`, {
          billing_account,
        });
      },
      // delete(billing_account_id) {
      //   return requestData("DELETE", `/billing_account/${billing_account_id}`);
      // },
      retire(billing_account_id, reason = null) {
        return requestData("POST", `/billing_account_retire/${billing_account_id}`, {
          reason,
        });
      },
      getApiKeys(billing_account_id) {
        return requestData(
          "GET",
          `/api_key_matching_billing_account/${billing_account_id}`,
        );
      },
    };
  }
}
